import React, { useState } from "react";
import AuxiliaryMachinary from "./AuxiliaryMachinary";
import Bwts from "./CargoMachineryFields/BwtsDetails";
import IGG from "./CargoMachineryFields/IggDetails";
import CargoCrane from "./CargoMachineryFields/CraneCorgo";
import LpgCargoCompressor from "./CargoMachineryFields/LpgCargoCompressor";
import LngCargoCompressor from "./CargoMachineryFields/LngCargoCompressor";
import NitrogenPlant from "./CargoMachineryFields/NitrogenPlant";
import Copt from "./CargoMachineryFields/Copt";
import Framo from "./CargoMachineryFields/Framo";

function SubTabCargoMachinary({ id, onSuccess }) {
  const [activeTab, setActiveTab] = useState("BWTS");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  const handleSubSuccess = (currentSubTab) => {
    const subTabOrder = [
      "BWTS",
      "IGG",
      "CargoCrane",
      "LpgCargoCompressor",
      "LngCargoCompressor",
      "NitrogenPlant",
      "Copt",
      "Framo",
    ];
    const currentIndex = subTabOrder.indexOf(currentSubTab);
    if (currentIndex !== -1 && currentIndex < subTabOrder.length - 1) {
      const nextSubTab = subTabOrder[currentIndex + 1];
      setActiveTab(nextSubTab);
      localStorage.setItem("engineLogbook", nextSubTab);
      window.scrollTo(0, 0);
    } else if (currentIndex === subTabOrder.length - 1) {
      if (onSuccess) onSuccess();
    }
  };
  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li className={activeTab === "BWTS" ? "active" : ""} onClick={() => handleClick("BWTS")}>
            BWTS
          </li>
          <li className={activeTab === "IGG" ? "active" : ""} onClick={() => handleClick("IGG")}>
            IGG
          </li>

          <li
            className={activeTab === "CargoCrane" ? "active" : ""}
            onClick={() => handleClick("CargoCrane")}
          >
            Cargo Crane
          </li>
          <li
            className={activeTab === "LpgCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LpgCargoCompressor")}
          >
            LPG Cargo Compressor
          </li>
          <li
            className={activeTab === "LngCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LngCargoCompressor")}
          >
            LNG Cargo Compressor
          </li>
          <li
            className={activeTab === "NitrogenPlant" ? "active" : ""}
            onClick={() => handleClick("NitrogenPlant")}
          >
            Nitrogen Plant
          </li>

          <li className={activeTab === "Copt" ? "active" : ""} onClick={() => handleClick("Copt")}>
            Copt
          </li>
          <li
            className={activeTab === "Framo" ? "active" : ""}
            onClick={() => handleClick("Framo")}
          >
            Framo
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "auxiliaryMachinary" && <AuxiliaryMachinary id={id} />}
        {activeTab == "BWTS" && <Bwts id={id} onSuccess={() => handleSubSuccess("BWTS")} />}
        {activeTab == "IGG" && <IGG id={id} onSuccess={() => handleSubSuccess("IGG")} />}
        {activeTab == "CargoCrane" && (
          <CargoCrane id={id} onSuccess={() => handleSubSuccess("CargoCrane")} />
        )}
        {activeTab == "LpgCargoCompressor" && (
          <LpgCargoCompressor id={id} onSuccess={() => handleSubSuccess("LpgCargoCompressor")} />
        )}
        {activeTab == "LngCargoCompressor" && (
          <LngCargoCompressor id={id} onSuccess={() => handleSubSuccess("LngCargoCompressor")} />
        )}
        {activeTab == "NitrogenPlant" && (
          <NitrogenPlant id={id} onSuccess={() => handleSubSuccess("NitrogenPlant")} />
        )}
        {activeTab == "Copt" && <Copt id={id} onSuccess={() => handleSubSuccess("Copt")} />}
        {activeTab == "Framo" && <Framo id={id} onSuccess={() => handleSubSuccess("Framo")} />}
      </div>
    </>
  );
}

export default SubTabCargoMachinary;
// import React, { useState } from "react";
